import React from 'react';

function Home() {
  return (
    <div className="min-h-screen font-sans text-gray-900">
      {/* Header */}
      {/* <header className="bg-secondary-950 text-white py-4">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold">Team Tech Roofing</h1>
          <nav>
            <ul className="flex space-x-6">
              <li><a href="#home" className="hover:text-primary-500">Home</a></li>
              <li><a href="#products" className="hover:text-primary-500">Products</a></li>
              <li><a href="#services" className="hover:text-primary-500">Services</a></li>
              <li><a href="#testimonials" className="hover:text-primary-500">Testimonials</a></li>
              <li><a href="#contact" className="hover:text-primary-500">Contact</a></li>
            </ul>
          </nav>
        </div>
      </header> */}

      {/* Hero Section */}
      <section className="py-16 px-4 bg-gray-100">
        <div className="container mx-auto flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold">Team Tech Roofing</h2>
            <p className="text-lg">
              At Team Tech Roofing, we are dedicated to revolutionizing the roofing industry with our commitment to quality, innovation, and customer satisfaction. With years of experience, we specialize in every aspect of roofing.
            </p>
            {/* Slider Controls Placeholder */}
            <div className="flex items-center space-x-4">
              <button className="text-primary-500 font-bold">Previous</button>
              <button className="text-primary-500 font-bold">Next</button>
            </div>
          </div>
          <div className="md:w-1/2 mt-8 md:mt-0">
            <img
              src="https://via.placeholder.com/600x400"
              alt="Hero placeholder"
              className="w-full rounded shadow"
            />
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="py-16 bg-primary-500 text-secondary-950">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <h3 className="text-3xl font-bold">3000+</h3>
              <p className="mt-2">PROJECTS</p>
            </div>
            <div>
              <h3 className="text-3xl font-bold">1200+</h3>
              <p className="mt-2">CLIENTS</p>
            </div>
            <div>
              <h3 className="text-3xl font-bold">15+</h3>
              <p className="mt-2">EXPERIENCE</p>
            </div>
            <div>
              <h3 className="text-3xl font-bold">3</h3>
              <p className="mt-2">BRANCHES</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 border rounded shadow hover:shadow-lg transition">
              <h4 className="text-2xl font-bold mb-2">Client Satisfaction</h4>
              <p>
                We prioritize our clients' needs, ensuring exceptional service and tailored solutions to exceed expectations.
              </p>
            </div>
            <div className="p-6 border rounded shadow hover:shadow-lg transition">
              <h4 className="text-2xl font-bold mb-2">Faster Delivery</h4>
              <p>
                Our efficient processes and dedicated team ensure timely delivery of all products and services, meeting your project deadlines.
              </p>
            </div>
            <div className="p-6 border rounded shadow hover:shadow-lg transition">
              <h4 className="text-2xl font-bold mb-2">Durability</h4>
              <p>
                We use high-quality materials and expert craftsmanship to guarantee long-lasting, reliable products for your construction needs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold">Innovative Solutions for Every Roof</h2>
            <h3 className="text-xl mt-2 text-primary-500 font-semibold">OUR PRODUCTS</h3>
          </div>
          <div className="space-y-6">
            <p>
              At Team Tech Roofing Company, we provide high-quality products for all your construction and roofing needs, including durable Roofing sheets, insulated Puff panel sheets, efficient Rain water gutters, reliable Industrial screws, and powerful Turbine fans.
            </p>
            <p>
              Trust us for innovative solutions that ensure durability, efficiency, and excellence in every project.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold">Expert Construction and Roofing Services</h2>
            <h3 className="text-xl mt-2 text-primary-500 font-semibold">OUR SERVICES</h3>
          </div>
          <div className="space-y-6">
            <p>
              We specialize in comprehensive construction and roofing services, including expert Roofing works, Pre-Engineered Building (PEB) solutions, and all types of Shed Construction (car parking, industrial, warehouse, garage, shops, houses, etc.). Additionally, we provide high-quality Sheet works for shelters and other structures.
            </p>
            <p>
              Trust us for reliable, efficient, and professional service in every project.
            </p>
          </div>
        </div>
      </section>

      {/* Trading Brands Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-8">TRADING BRANDS</h2>
          {/* Placeholder logos */}
          <div className="flex flex-wrap justify-center items-center gap-8">
            <img src="https://via.placeholder.com/100x50" alt="Brand 1" className="object-contain" />
            <img src="https://via.placeholder.com/100x50" alt="Brand 2" className="object-contain" />
            <img src="https://via.placeholder.com/100x50" alt="Brand 3" className="object-contain" />
            <img src="https://via.placeholder.com/100x50" alt="Brand 4" className="object-contain" />
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-16 bg-secondary-950 text-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">TESTIMONIALS</h2>
          <div className="bg-gray-800 rounded p-8 max-w-2xl mx-auto">
            <p className="italic mb-4">
              "Team Tech Roofing delivered exactly what we needed for our project. Their roofing sheets are top-notch in quality and durability. The customization options allowed us to achieve the exact look we wanted. Highly recommended!"
            </p>
            <p className="font-bold">Rahul Raaj • Raaj Motors</p>
          </div>
          {/* Slider Controls Placeholder */}
          <div className="flex justify-center items-center space-x-4 mt-6">
            <button className="text-primary-500 font-bold">Previous</button>
            <button className="text-primary-500 font-bold">Next</button>
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="py-16">
        <div className="container mx-auto px-4 text-center">
          <p className="text-xl mb-4">
            Over 3,000+ roofing projects completed with our supplies.
          </p>
          <p className="text-lg">
            Get in touch with us to get a quote or to schedule a consultation.
          </p>
        </div>
      </section>

      {/* Footer */}
      {/* <footer className="bg-gray-800 text-white py-4">
        <div className="container mx-auto px-4 text-center">
          <p>&copy; {new Date().getFullYear()} Team Tech Roofing. All rights reserved.</p>
        </div>
      </footer> */}
    </div>
  );
}

export default Home;
